export default __webpack_public_path__ + "static/media/7.aab874d9.jpeg";